import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { DocumentTypeService } from '../../../../core/services/document/document-type/document-type.service'
import { MatOptionModule } from "@angular/material/core";
import { AngularMaterialModule } from "../../../../core/modules/angular-material/angular-material.module";
import { MatSelect, MatSelectModule } from '@angular/material/select'
import { SupplierService } from '../../../../core/services/person/supplier/supplier.service'
import { MatListModule } from "@angular/material/list";
import { CreateSupplierFormModel, uploadDocSupplier } from '../../../../core/models/supplier.model'

@Component({
  selector: 'document-upload-form-edit',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatFormField,
    MatInput,
    MatLabel,
    MatOptionModule,
    MatSelectModule,
    AngularMaterialModule,
    MatListModule
  ],
  templateUrl: './document-upload-form.component.html',
  styleUrl: './document-upload-form.component.scss',
  providers: [DocumentTypeService],
  standalone: true,
})
export class DocumentUploadFormEdit implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private documentTypeService: DocumentTypeService,
    private supplierService: SupplierService,
    private snackbar: SnackbarCustomService,
  ) { }

  @Output() responseCreate = new EventEmitter()
  @Output() response = new EventEmitter<any>()
  @Input() item: any
  documentList: any[] = []
  @Input() fornecedorId: any

  fileName: any = '';
  listType: any[] = []
  file: File | null = null
  allowedTypes = []
  form: FormGroup = new FormGroup({})
  loading: boolean = false

  ngOnInit(): void {
    this.createForm()
    this.getListTypeDoc()
    console.log('Id do fornecedor: ', this.fornecedorId)
  }

  // createItem() {
  //   this.loading = true
  //   const model = this.createModel()
  //   this.documentTypeService.createDocumentType(model).subscribe({
  //     next: (response: ResponseRequestModel) => {
  //       this.snackbar.success(response.message)
  //       this.responseCreate.emit()
  //     },
  //     error: (err: ErrorRequestModel) => {
  //       this.loading = false
  //       this.snackbar.errorRequest(err)
  //     },
  //     complete: () => {
  //       this.loading = false
  //       this.form.reset()
  //     },
  //   })
  // }


  createModel() {
    return {
      TipoDocId: this.form.controls['docType'].value,
      FornecedorId: 1,
      Arquivo: this.file,
      Descricao: this.form.controls['description'].value,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      file: [''],
      docType: [''],
      description: [''],
    })
  }
  getListTypeDoc() {
    this.documentTypeService.listDocumentType().subscribe({
      next: (response: any) => {
        this.listType = response.data
      },
      error: (err: any) => {
        console.error(err)
      },
      complete: () => { },
    })
  }



  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.file = input.files[0];
      this.fileName = this.file.name;
      this.form.get('file')?.setValue(this.file.name);
    } else {
      this.file = null;
      this.fileName = '';
      this.form.get('file')?.setValue('');
    }


  }
  getAllowedTypes() {
    return this.allowedTypes.map((item) => `.${item}`).join(', ')
  }


  addDocument() {
    if (this.form.invalid || !this.file) {
      this.snackbar.error('Preencha todos os campos e selecione um arquivo');
      return;
    }

    this.supplierService.uploadDocSupplier(this.createModal()).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        const newDocument = response.data
        newDocument.action = 'edit'
        
        this.response.emit(newDocument)
      },
      error: (err: any) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })



    // Reset do formulário
    this.form.reset();
    this.file = null;
    this.fileName = '';
  }

  createModal() {
    const model = new uploadDocSupplier()
    
    model.arquivo = {
      FileObject: this.file,
      descricao: this.form.get('description')?.value,
      fornecedorId: this.fornecedorId,
      tipoDocId: this.form.get('docType')?.value?.id
    }

    return model.toFormData()
  }


  removeDocument(index: number) {
    this.documentList.splice(index, 1);
    this.response.emit(this.documentList); // Emite a lista atualizada
  }
}
